export const oidcSettings = {
  authority: import.meta.env.VITE_APP_SSO_URL,
  client_id: import.meta.env.VITE_APP_SSO_CLIENT_ID_FRONT,
  redirect_uri: `${window.location.origin}/oidc-callback`,
  post_logout_redirect_uri: `${window.location.origin}`,
  responseType: "code",
  scope: "openid profile email",
  automaticSilentRenew: true,
  validateSubOnSilentRenew: true,
  monitorSession: false,
  revokeAccessTokenOnSignout: true,
  accessTokenExpiringNotificationTime: 3 * 60,
  loadUserInfo: true,
};
